// extracted by mini-css-extract-plugin
export default {"sticky":"tableTopScrollbar_sticky__IIlrp","bar":"tableTopScrollbar_bar__fIR78","hidden":"tableTopScrollbar_hidden__eQddB","spacer":"tableTopScrollbar_spacer__5jWOv"};